module.exports = __webpack_public_path__ + "dca95a4dd39858c4051a13e4f8793edd.png";